var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudsSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 29,
    fill: "currentColor",
    viewBox: "0 0 36 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.1 8.96c-4.168 0-7.605 3.136-8.05 7.168H5.4c-2.981 0-5.4-2.408-5.4-5.376 0-2.968 2.419-5.376 5.4-5.376h.062A6.296 6.296 0 0 1 11.7 0a6.304 6.304 0 0 1 5.895 4.054 5.367 5.367 0 0 1 2.205-.47c2.981 0 5.4 2.408 5.4 5.376 0 .678-.124 1.322-.354 1.915a6.295 6.295 0 0 0-1.806.667A8.087 8.087 0 0 0 17.1 8.96Zm-4.5 19.713c-2.981 0-5.4-2.408-5.4-5.376a5.379 5.379 0 0 1 3.707-5.108 6.1 6.1 0 0 1-.107-1.165c0-3.466 2.818-6.272 6.3-6.272a6.295 6.295 0 0 1 5.58 3.36 4.511 4.511 0 0 1 3.42-1.568c2.486 0 4.5 2.005 4.5 4.48 0 .308-.034.605-.09.896h.09c2.981 0 5.4 2.408 5.4 5.377 0 2.968-2.419 5.376-5.4 5.376h-18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v28.673H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsSolid);
export default __webpack_public_path__ + "static/media/clouds-solid.045d4c896193fb2326b6c7bd37d59875.svg";
export { ForwardRef as ReactComponent };